import md5 from 'js-md5';

export function generateSigNew(signStr,timestamp) {
    var salt = 'b^s17OpehAi@xWfqdSeH'
    var arr = [1,1,2,3,5,8,13,21]
    try{
        //连接salt和timestamp生成MD5小写32位字符串，得到_code1
        var str = salt+timestamp;
        var code1 = md5(str);
        var code2Builder = '';
        for(var i=0; i<arr.length; i++){
            code2Builder+=code1.charAt(arr[i])
        }
        //连接_code2Builder和salt，再次生MD5小写32位字符串，得到_code3
        var secondStr = signStr+code2Builder+salt+timestamp.toString()
        var code3 = md5(secondStr);

        //对_code3取费波拉契线序列8位
        var sigBuilder = ''
        for(var i=0; i<arr.length; i++){
            sigBuilder+=code3.charAt(arr[i])
        }
        return sigBuilder.toString();
    }catch (e) {
        console.error(e)
        return '';
    }
}


